export default [
  {
    path: 'developer/notify',
    name: 'Developer Notify',
    component: () => import('@/views/developer/notify/index.vue'),
    meta: {
      icon: 'icon-kaifazhe',
      resourceCode: 'developer:notify',
    },
  },
];
